import React, { useEffect } from "react";
import { ToastContainer } from "react-toastify";
import { useNavigate } from "react-router-dom";
import AppRoutes from "./routes";
import "./App.scss";
import { setNavigationCallback } from "./api/client";

import Header from "./Components/Header/Header";
import { useAppContext } from "./Components/Context/AppContext";

function App() {
  const navigate = useNavigate();
  const { theme } = useAppContext();

  useEffect(() => {
    // Set up navigation callback for 401 errors
    setNavigationCallback(navigate);
  }, [navigate]);

  return (
    <div className="App">
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme={theme === "night" ? "dark" : "light"}
      />
      <Header />
      <div className="app-routes">
        <AppRoutes />
      </div>
    </div>
  );
}

export default App;
